'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleViewController = function () {
  function VehicleViewController(authService, $stateParams, enums, vehicleService, loadingService, $state, lookupService, $q, retailPriceListService, deliveryPriceManagementService) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, VehicleViewController);
    if (!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.View)) {
      return;
    }

    this.authService = authService;
    this.$stateParams = $stateParams;
    this.vehicleService = vehicleService;
    this.loadingService = loadingService;
    this.enums = enums;
    this.$state = $state;
    this.lookupService = lookupService;
    this.$q = $q;
    this.retailPriceListService = retailPriceListService;
    this.deliveryPriceManagementService = deliveryPriceManagementService;

    this.vehicle = null;

    //For Selecting multiple vehicles when its a Trader contact type
    this.selectedVehicles = [];

    if (!$stateParams.enquiry) {
      $state.go('welcomeCentre');
      return;
    }

    this.selectOptions = {};
    this.criteria = {};
    this.deliveryPriceList = [];

    //If this is for a multi select contact
    this.isMultiSelect = $stateParams.enquiry.contactType === enums.CONTACT_TYPE.Trader;

    //Initialization
    this.initializeVehicleConditions();
    this.initializeLookups().then(function () {
      _this.updateBrands(_this.$stateParams.enquiry.criteria.condition);
      _this.listDeliveryPriceList();
    });

    this.isSingleView = $stateParams.vehicleId !== null;
  }

  (0, _createClass3.default)(VehicleViewController, [{
    key: 'initializeLookups',
    value: function initializeLookups() {
      var _this2 = this;

      var ctrl = this;
      var deferred = ctrl.$q.defer();

      this.lookupService.lookupBrands().then(function (brands) {
        brands.splice(0, 1);
        _this2.allBrands = brands;
        _this2.brands = _this2.allBrands;
        _this2.brands.unshift({ brandId: null, name: 'Any Brand' });

        _this2.criteria.brand = _this2.brands[0];

        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
          _this2.allBrandModels = brandModels;
          _this2.updateBrandModel();

          _this2.initializeMyLocations().then(function () {
            _this2.initializeEnums();
            deferred.resolve();
          });
        });
      });

      return deferred.promise;
    }
  }, {
    key: 'initializeVehicleConditions',
    value: function initializeVehicleConditions() {
      this.selectOptions.condition = [{ id: null, name: "Please Select" }, { id: 0, name: "New Order" }, { id: 1, name: "New (In Stock)" }, { id: 2, name: "Used (In Stock)" }];

      if (this.isMultiSelect) {
        this.selectOptions.condition = (0, _lodash.without)(this.selectOptions.condition, this.selectOptions.condition[1]);
      }
    }
  }, {
    key: 'initializeMyLocations',
    value: function initializeMyLocations() {
      var _this3 = this;

      var promise = this.lookupService.lookupMyLocations(this.authService.authData.currentLocation.key);

      promise.then(function (response) {
        _this3.myLocations = response.data;
      });

      return promise;
    }
  }, {
    key: 'updateBrandModel',
    value: function updateBrandModel() {
      if (this.criteria.condition === 0) {
        this.updateBrandModelPriceList();
      } else {
        this.updateBrandModelStock();
      }
    }
  }, {
    key: 'updateBrandModelStock',
    value: function updateBrandModelStock() {
      var _this4 = this;

      var ctrl = this;

      if (ctrl.criteria.condition === 0) {
        /*
        * #577
        * This is to display only the brand models that we have the models available
        * in retail price list. This is to reduce customer selecting a brand model
        * clicking search and no results returned, this will make sure
        * that if there is a brand model and you search for that
        * there will be variants for that
        */
        var locationBrandModelIds = (0, _lodash.map)((0, _lodash.uniqBy)(ctrl.allVehiclesPriceList, 'brandModelId'), function (o) {
          return o.brandModelId;
        });
        var locationBrandModels = (0, _lodash.map)(ctrl.allBrandModels, function (o) {
          var hasBrandModel = (0, _lodash.find)(locationBrandModelIds, function (brandModelId) {
            return brandModelId === o.brandModelId;
          });
          if (hasBrandModel) {
            return o;
          }
        });

        locationBrandModels = (0, _lodash.filter)(locationBrandModels, function (o) {
          return o;
        });
        this.brandModels = (0, _lodash.filter)(locationBrandModels, function (o) {
          return o.brandId === _this4.criteria.brand.brandId;
        });
      } else {
        this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
          return o.brandId === _this4.criteria.brand.brandId;
        });
      }

      this.brandModels.unshift({ brandModelId: null, name: 'Any Model' });

      this.criteria.brandModel = this.brandModels[0];
    }
  }, {
    key: 'updateBrandModelPriceList',
    value: function updateBrandModelPriceList() {
      var ctrl = this;

      if (!this.criteria.brand.brandId) {
        return;
      }

      ctrl.loadingService.showLoading('vehicleView', 'Loading Vehicles');

      ctrl.retailPriceListService.getRetailPriceListsByBrandId(this.criteria.brand.brandId).then(function (response) {
        ctrl.vehicles = [];
        ctrl.allVehiclesPriceList = response.data.items;
        ctrl.updateBrandModelStock();
        ctrl.updateBodyTypes();
      }).catch(function (err) {}).finally(function () {
        ctrl.loadingService.hideLoading('vehicleView');
      });
    }
  }, {
    key: 'initializeEnums',
    value: function initializeEnums() {
      var ctrl = this;
      var enumList = [{ enumName: 'VEHICLE_BODY_TYPE', propName: 'bodyType', propNameU: 'BodyTypes', defaultOption: true, defaultText: 'Any Body Type' }, { enumName: 'FUEL_TYPE', propName: 'fuelType', propNameU: 'FuelTypes', defaultOption: true, defaultText: 'Any Fuel Type' }, { enumName: 'TRANSMISSION_TYPE', propName: 'transmissionType', propNameU: 'TransmissionType', defaultOption: true, defaultText: 'Any Transmission Type' }];

      enumList.map(function (item) {
        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption, item.defaultText);
        ctrl['all' + item.propNameU] = enumsArray;
        ctrl.selectOptions[item.propName] = enumsArray;
      });

      ctrl.reset(ctrl.$stateParams.enquiry.criteria, ctrl.$stateParams.condition);
    }
  }, {
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption, defaultText) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: defaultText || 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'reset',
    value: function reset(criteria, initialCondition) {
      var ctrl = this;

      if (criteria) {
        ctrl.criteria = criteria;

        criteria.brand = (0, _lodash.find)(ctrl.brands, function (o) {
          return o.brandId === criteria.brandId;
        });
        ctrl.updateBrandModel();
        criteria.brandModel = (0, _lodash.find)(ctrl.brandModels, function (o) {
          return o.brandModelId === criteria.brandModelId;
        });
      } else {
        ctrl.criteria.enquiryId = ctrl.$stateParams.enquiry.enquiryId;
        ctrl.criteria.condition = initialCondition || null;
        ctrl.criteria.bodyType = null;
        ctrl.criteria.fuelType = null;
        ctrl.criteria.transmissionType = null;
        ctrl.criteria.capacityFrom = null;
        ctrl.criteria.capacityTo = null;
        ctrl.criteria.yearFrom = null;
        ctrl.criteria.yearTo = null;
        ctrl.criteria.priceFrom = null;
        ctrl.criteria.priceTo = null;
        ctrl.criteria.brand = ctrl.brands[0];
        ctrl.updateBrands();
        ctrl.updateBrandModel();
      }

      ctrl.criteria.entityId = ctrl.authService.authData.currentLocation.key;
      ctrl.searchVehicles();
    }
  }, {
    key: 'searchVehicles',
    value: function searchVehicles() {
      var _this5 = this;

      var ctrl = this;

      if (ctrl.criteria.condition === 0) {
        ctrl.filterRetailPriceLists();
        return;
      }

      ctrl.vehicle = null;
      ctrl.errMsg = null;
      ctrl.loadingService.showLoading('vehicleView', 'Loading Vehicles');

      ctrl.criteria.brandId = ctrl.criteria.brand.brandId;
      ctrl.criteria.brandModelId = ctrl.criteria.brandModel.brandModelId;

      ctrl.vehicleService.searchVehicles(ctrl.criteria.entityId, ctrl.criteria).then(function (response) {
        //Update Enquiry Search criteria
        ctrl.criteria.brand = (0, _lodash.find)(ctrl.brands, function (o) {
          return o.brandId === ctrl.criteria.brandId;
        });
        ctrl.updateBrandModel();
        ctrl.criteria.brandModel = (0, _lodash.find)(ctrl.brandModels, function (o) {
          return o.brandModelId === ctrl.criteria.brandModelId;
        });
        ctrl.$stateParams.enquiry.criteria = ctrl.criteria;

        ctrl.vehicles = response.data.items;

        if (ctrl.vehicles.length) {
          if (!_this5.isMultiSelect) {
            if (ctrl.$stateParams.vehicleId) {
              ctrl.vehicle = (0, _lodash.find)(_this5.vehicles, function (o) {
                return o.vehicleId === ctrl.$stateParams.vehicleId;
              });
            } else {
              ctrl.vehicle = _this5.vehicles[0];
            }
          } else {
            _this5.selectedVehicles = [];
          }
        }
      }).catch(function (err) {}).finally(function () {
        ctrl.loadingService.hideLoading('vehicleView');
      });
    }
  }, {
    key: 'updateVehicleMedia',
    value: function updateVehicleMedia(id) {
      jQuery('#myCarousel').carousel(parseInt(id));

      jQuery('video.carousel').each(function (i, val) {
        val.pause();
      });
    }
  }, {
    key: 'selectEnquiryVehicle',
    value: function selectEnquiryVehicle() {
      if (!this.vehicle && !this.selectedVehicles.length) {
        this.errMsg = "Please select a vehicle first";
        return;
      }

      this.selectVehicle();
    }
  }, {
    key: 'selectVehicle',
    value: function selectVehicle() {
      if (this.isMultiSelect) {
        this.multiSelectVehicles();
      } else {
        if (this.criteria.condition === 0) {
          this.selectVehiclePriceList();
        } else {
          this.selectVehicleStock();
        }
      }
    }
  }, {
    key: 'selectVehicleStock',
    value: function selectVehicleStock() {
      var _this6 = this;

      var isNew = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.errMsg = '';

      if (this.vehicle.entityId !== this.authService.authData.currentLocation.key) {
        var sure = window.confirm('This vehicle is not in your location are you sure you want to add it ?');
        if (!sure) {
          return;
        }
      }

      var dupVehicle = (0, _lodash.find)(this.$stateParams.enquiry.enquiryVehicles, function (o) {
        return o.vehicleId === _this6.vehicle.vehicleId;
      });

      if (!dupVehicle) {
        var enquiryVehicle = {
          vehicleId: this.vehicle.vehicleId,
          vehicle: this.vehicle,
          isSelected: false,
          isRemoved: false
        };

        this.$stateParams.enquiry.enquiryVehicles.push(enquiryVehicle);

        //Add a unconfirmed test drive for this selected vehicle
        this.$stateParams.enquiry.testDrives.push({
          vehicleId: this.vehicle.vehicleId,
          model: this.vehicle.model,
          comments: null,
          timeStamp: null,
          isConfirmed: false
        });

        /*
        * This is a price book vehicle
        * Need to check if there's not a delivery price extra to this enquiry
        * then add one
        */
        if (isNew && this.vehicle.defaultDeliveryPrice) {
          var deliveryPrice = (0, _lodash.find)(this.$stateParams.enquiry.enquiryPrices, function (o) {
            return o.groupType === _this6.enums.ENQUIRY_PRICE_GROUP_TYPE.Extras && o.name === 'Delivery Price';
          });

          if (deliveryPrice) {
            deliveryPrice.amount = this.vehicle.defaultDeliveryPrice;
          } else {
            this.$stateParams.enquiry.enquiryPrices.push({
              priceType: this.enums.ENQUIRY_PRICE_TYPE.Cost,
              groupType: this.enums.ENQUIRY_PRICE_GROUP_TYPE.Extras,
              name: 'Delivery Price',
              amount: this.vehicle.defaultDeliveryPrice,
              removed: false
            });
          }
        }

        this.redirectToParent();
      } else {
        this.errMsg = 'This vehicle is already added to the enquiry';
      }
    }
  }, {
    key: 'selectVehiclePriceList',
    value: function selectVehiclePriceList() {
      var _this7 = this;

      this.loadingService.showLoading('vehicleView', 'Saving Changes ...');

      //Create Vehicle From Price List first
      this.vehicleService.createFromPriceList(this.authService.authData.currentLocation.key, this.vehicle.vehicleId).then(function (response) {
        _this7.vehicle = response.data;
        _this7.selectVehicleStock(true);
      }).finally(function () {
        _this7.loadingService.hideLoading('vehicleView');
      });
    }
  }, {
    key: 'redirectToParent',
    value: function redirectToParent(isCancel) {
      var _this8 = this;

      /*
      * This request is coming form Welcome Centre,
      * so assume the selected vehicle is of interest to the customer
      */
      if (!isCancel && this.$stateParams.enquiry.enquiryVehicles.length) {
        this.$stateParams.enquiry.enquiryVehicles.map(function (ev) {
          ev.isSelected = false;
        });

        var ev = this.$stateParams.enquiry.enquiryVehicles[this.$stateParams.enquiry.enquiryVehicles.length - 1];
        ev.isSelected = true;
        var costPrice = (0, _lodash.find)(this.$stateParams.enquiry.enquiryPrices, function (o) {
          return o.priceType === _this8.enums.ENQUIRY_PRICE_TYPE.Cost && o.groupType === _this8.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing;
        });

        if (costPrice) {
          costPrice.amount = ev.vehicle.price || 0;
        } else {
          this.$stateParams.enquiry.enquiryPrices.push({
            priceType: this.enums.ENQUIRY_PRICE_TYPE.Cost,
            groupType: this.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
            name: 'Vehicle Price',
            amount: ev.vehicle.price || 0
          });
        }
      }

      if (this.$stateParams.source === 'welcomeCentre') {
        this.$state.go('welcomeCentre', {
          enquiry: this.$stateParams.enquiry
        });
      } else {
        var _ev = this.$stateParams.enquiry.enquiryVehicles[this.$stateParams.enquiry.enquiryVehicles.length - 1];

        if (_ev && !this.$stateParams.enquiry.subject) {
          this.$stateParams.enquiry.subject = _ev.vehicle.model + ' ' + _ev.vehicle.variant;
        }

        if (_ev && !this.$stateParams.enquiry.amountToSpend) {
          this.$stateParams.enquiry.amountToSpend = _ev.vehicle.price;
        }

        if (this.$stateParams.enquiry.enquiryId) {
          this.$state.go('enquiryEdit', {
            enquiryId: this.$stateParams.enquiry.enquiryId,
            enquiry: this.$stateParams.enquiry,
            activeTab: 'vehicles'
          });
        } else {
          this.$state.go('enquiryAdd', {
            enquiry: this.$stateParams.enquiry,
            activeTab: 'vehicles'
          });
        }
      }
    }
  }, {
    key: 'updateBrands',
    value: function updateBrands(initialCondition) {
      var condition = initialCondition || this.criteria.condition;

      if (this.criteria.condition === 0) {
        var locationBrandIds = this.authService.getLocationBrands(this.enums.PERMISSION_TYPE.View);
        var allBrands = (0, _lodash.find)(locationBrandIds, function (o) {
          return o === 1;
        });

        if (allBrands) {
          this.brands = this.allBrands.map(function (b) {
            return b;
          }).splice(1);
        } else {
          this.brands = (0, _lodash.filter)(this.allBrands, function (o) {
            return (0, _lodash.includes)(locationBrandIds, o.brandId);
          });
        }

        this.criteria.brand = this.brands[0];
        this.updateBrandModelPriceList();
        this.filterRetailPriceLists();
      } else {
        this.brands = this.allBrands;
        this.criteria.brand = this.brands[0];
        this.updateBrandModel();
        this.updateBodyTypes();
      }
    }
  }, {
    key: 'updateBodyTypes',
    value: function updateBodyTypes() {
      var _this9 = this;

      if (this.criteria.condition === 0) {
        var availableModels = (0, _lodash.filter)(this.allVehiclesPriceList, function (o) {
          return o.brandModelId === _this9.criteria.brandModel.brandModelId;
        });
        var bodyTypeIds = (0, _lodash.filter)((0, _lodash.map)((0, _lodash.uniqBy)(availableModels, 'bodyTypeId'), function (o) {
          return o.bodyTypeId;
        }), function (o) {
          return o;
        });
        this.selectOptions.bodyType = (0, _lodash.filter)(this.allBodyTypes, function (o) {
          return (0, _lodash.includes)(bodyTypeIds, o.id);
        });
        this.selectOptions.bodyType.unshift({ id: null, name: 'Any Body Type' });
        this.criteria.bodyType = this.selectOptions.bodyType[0].id;
      } else {
        this.selectOptions.bodyType = this.allBodyTypes;
        this.criteria.bodyType = this.selectOptions.bodyType[0].id;
      }
    }
  }, {
    key: 'filterRetailPriceLists',
    value: function filterRetailPriceLists() {
      var selectedVehicles = (0, _lodash.filter)(this.allVehiclesPriceList, this.vehicleSelector.bind(this));

      this.vehicles = selectedVehicles;
      this.vehicle = this.vehicles[0];
    }
  }, {
    key: 'vehicleSelector',
    value: function vehicleSelector(v) {
      var shouldSelect = false;

      if (this.criteria.brandModel.brandModelId) {
        shouldSelect = v.brandModelId === this.criteria.brandModel.brandModelId;
      } else {
        shouldSelect = true;
      }

      if (this.criteria.bodyType) {
        shouldSelect &= v.bodyTypeId === this.criteria.bodyType;
      } else {
        shouldSelect &= true;
      }

      if (this.criteria.transmissionType) {
        shouldSelect &= v.transmissionTypeId === this.criteria.transmissionType;
      } else {
        shouldSelect &= true;
      }

      if (this.criteria.fuelType) {
        shouldSelect &= v.fuelTypeId === this.criteria.fuelType;
      } else {
        shouldSelect &= true;
      }

      if (this.criteria.fuelType) {
        shouldSelect &= v.fuelTypeId === this.criteria.fuelType;
      } else {
        shouldSelect &= true;
      }

      if (this.criteria.capacityFrom) {
        shouldSelect &= v.capacity >= this.criteria.capacityFrom;
      } else {
        shouldSelect &= true;
      }

      if (this.criteria.capacityTo) {
        shouldSelect &= v.capacity <= this.criteria.capacityTo;
      } else {
        shouldSelect &= true;
      }

      if (this.criteria.priceFrom) {
        shouldSelect &= v.price >= this.criteria.priceFrom;
      } else {
        shouldSelect &= true;
      }

      if (this.criteria.priceTo) {
        shouldSelect &= v.price <= this.criteria.priceTo;
      } else {
        shouldSelect &= true;
      }

      return shouldSelect;
    }
  }, {
    key: 'listDeliveryPriceList',
    value: function listDeliveryPriceList() {
      var _this10 = this;

      this.deliveryPriceManagementService.listDeliveryPrices(this.$stateParams.enquiry.entityId).then(function (response) {
        _this10.deliveryPriceList = response.data.items;
      });
    }
  }, {
    key: 'multi_selectUnselectVehicle',
    value: function multi_selectUnselectVehicle(v) {
      if (this.multi_isVehicleSelected(v)) {
        this.selectedVehicles = (0, _lodash.without)(this.selectedVehicles, v);
      } else {
        this.selectedVehicles.push(v);
      }
    }
  }, {
    key: 'multi_isVehicleSelected',
    value: function multi_isVehicleSelected(v) {
      return (0, _lodash.find)(this.selectedVehicles, function (o) {
        return o.vehicleId === v.vehicleId;
      });
    }
  }, {
    key: 'multiSelectVehicles',
    value: function multiSelectVehicles() {
      var _this11 = this,
          _$stateParams$enquiry;

      this.errMsg = '';

      //If any vehicle outside for current location
      var matching_External = (0, _lodash.filter)(this.searchVehicles, function (o) {
        return o.entityId === _this11.authService.authData.currentLocation.key;
      });
      if (matching_External.length > 0) {
        var sure = window.confirm('Certain vehicles are outside your current location. Are you sure you want to add them all?');
        if (!sure) {
          return;
        }
      }

      //Check for duplicate vehicles
      var dupVehicles = (0, _lodash.filter)(this.$stateParams.enquiry.enquiryVehicles, function (o) {
        return (0, _lodash.find)(_this11.selectedVehicles, function (sv) {
          return sv.vehicleId === o.vehicleId;
        });
      });
      if (dupVehicles.length) {
        this.errMsg = 'Thie following vehicles have already been added to the enquiry. ' + dupVehicles.map(function (v) {
          return v.vehicle.registration;
        }).toString();
        return;
      }

      //Get the selected enquiry vehicles
      var enquiryVehiclesToAdd = this.selectedVehicles.map(function (v) {
        return {
          vehicleId: v.vehicleId,
          vehicle: v,
          isSelected: true,
          isRemoved: false
        };
      });

      (_$stateParams$enquiry = this.$stateParams.enquiry.enquiryVehicles).push.apply(_$stateParams$enquiry, (0, _toConsumableArray3.default)(enquiryVehiclesToAdd));

      //Set the enquiry subject
      if (!this.$stateParams.enquiry.subject) {
        this.$stateParams.enquiry.subject = 'Trade Deal';
      }

      this.$state.go('enquiryEdit', {
        enquiryId: this.$stateParams.enquiry.enquiryId,
        enquiry: this.$stateParams.enquiry,
        activeTab: 'vehicles'
      });
    }
  }]);
  return VehicleViewController;
}();

exports.default = VehicleViewController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleList/vehicleView/vehicleView.controller.js